import { render, staticRenderFns } from "./EtaCounter.vue?vue&type=template&id=0c6a3d7e&scoped=true&"
import script from "./EtaCounter.vue?vue&type=script&lang=js&"
export * from "./EtaCounter.vue?vue&type=script&lang=js&"
import style0 from "./EtaCounter.vue?vue&type=style&index=0&id=0c6a3d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a3d7e",
  null
  
)

export default component.exports